import React,{ useEffect, useState } from 'react';
import SpicyLevel from '../options/SpicyLevel';
import Remark from '../options/Remark';
import Amount from '../options/Amount';
const Vagetable_Options = ({ handleCheckChange, formValues, handleInputChange, handleAdd, handleSubtract }) => {
  
  return (
    <>
      <SpicyLevel handleCheckChange={handleCheckChange}/>
      <Remark formValues = { formValues }  handleInputChange = { handleInputChange }/>
      <Amount handleAdd={ handleAdd } handleSubtract={ handleSubtract } formValues = { formValues }/>
    </>

  );
};

export default Vagetable_Options;
